<template>
  <div class="TemplateText">
    <scroll ref="scroll" class="scrollBox"
      :data="wishData"
      :haveBottom="true"
      :logoDisplay="true"
      :pullUpLoad="pullUpLoadObj"
      :pullDownRefresh="pullDownRefreshObj"
      @pullingUp="onPullingUp"
      @pullingDown="onPullingDown">
      <div class="scroll-content" v-if="baseData">
        <div class="banner" v-if="baseData.banner_pic">
          <img :src="baseData.banner_pic" alt="" @click="bannerClick(baseData.banner_link)">
        </div>
        <div class="premium" v-if="hotData">
          <div class="title">
            <i class="iconfont icon-jingxuan"></i>&nbsp;
            <span>精选</span>
          </div>
          <div class="content">
            <div class="item" v-for="(item, index) in hotData.slice(0, hotLength)" :key="index">
              <div class="item-avatar">
                <div class="avatar">
                  <img :src="item.avatar_url" alt="">
                </div>
              </div>
              <div class="item-content">
                <div class="item-content-top">
                  <div class="top-left">
                    <div class="name">{{item.nickname}}</div>
                    <div class="time">{{item.created_at}}</div>
                  </div>
                  <div class="top-right wishwall-like" v-if="baseData.enable_favor === 1" :class="{active: item.is_favor}" @click="zan('hot', index, item.wish_id, item.is_favor, item.favor_count)">
                    <i class="iconfont icon-dianzan"></i>
                    <span>{{item.favor_count}}</span>
                  </div>
                </div>
                <div class="item-content-bottom">
                  <div class="text">
                    {{item.content | filterA(item.show)}}
                    <!-- 查看全部 -->
                    <span class="showMore"
                      @click="showMore(item, index)"
                      v-show="item.content.length > 76"
                      v-if="!item.show">全部</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="hotToggoleArea" v-if="hotMore" @click="toggleHot">
            <div class="more">
              <span>更多精选</span>&nbsp;
              <i class="iconfont icon-xiangxia"></i>
            </div>
          </div>
        </div>
        <div class="latest">
          <div class="title">
            <i class="iconfont icon-zuixin"></i>&nbsp;
            <span>最新</span>
          </div>
          <div class="content" v-if="wishData">
            <div class="item" v-for="(item, index) in wishData" :key="index">
              <div class="item-avatar">
                <div class="avatar">
                  <img :src="item.avatar_url" alt="">
                </div>
              </div>
              <div class="item-content">
                <div class="item-content-top">
                  <div class="top-left">
                    <div class="name">{{item.nickname}}</div>
                    <div class="time">{{item.created_at}}</div>
                  </div>
                  <div class="top-right  wishwall-like" v-if="baseData.enable_favor === 1" :class="{active: item.is_favor}" @click="zan('normal', index, item.wish_id, item.is_favor, item.favor_count)">
                    <i class="iconfont icon-dianzan"></i>
                    <span>{{item.favor_count}}</span>
                  </div>
                </div>
                <div class="item-content-bottom">
                  <div class="text">
                    {{item.content | filterA(item.show)}}
                    <!-- 查看全部 -->
                    <span class="showMore"
                      v-show="item.content && item.content.length > 76"
                      v-if="!item.show"
                      @click="lineToggle(item, index)">全部</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </scroll>
    <div class="operation" v-if="baseData">
      <div class="item item-wish" @click="wishClick">{{baseData.button_text}}</div>
      <div class="item item-message" @click="messageClick">
        <i class="iconfont icon-wode"></i>
      </div>
    </div>
    <!-- 许愿文本框 -->
    <div class="wishLayer easein" v-show="wishTextareaDisplay" @click="btnClose" @touchmove.prevent>
      <div class="wishArea" @click.stop>
        <div class="wishArea-textarea">
          <textarea ref="textarea" name="" id="" placeholder="请填写留言" @blur="blurAction" v-model="wishText"></textarea>
          <div class="countArea">{{wishText.length}} / 500</div>
        </div>
        <div class="wishArea-btn">
          <div class="btn btn-confirm wishwall-comment"
            :class="{active: wishText.length > 3}"
            @click="btnConfirm">
            发送
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSticky, getWish, getChangeisfavor, getPushwish } from 'api'
import Scroll from '@/base/scroll/scroll.vue'
import { resetScrollTop, getDate } from '../assets/js/tool'

export default {
  name: 'TemplateText',
  props: {
    baseData: {
      type: Object
    },
    query: {
      type: Object
    },
    itemStatus: {
      type: Number
    },
    rightClass: {
      type: Boolean
    },
    logout: {
      type: Boolean
    },
    needFocus: {
      type: Boolean
    },
    exceptionUA: {
      type: Object
    },
  },
  data() {
    return {
      hotData: null,
      hotLength: 6,
      wishData: null,
      lineLimitArr: null,
      pullUpLoad: true,
      pullDownRefresh: true,
      pullDownRefreshThreshold: 90,
      pullDownRefreshStop: 40,
      wishText: '',
      wishTextCopy: '',
      wishTextareaDisplay: false,
      hotMore: false, // 更多精选
      hotPage: 1, // 置顶数据page
      wishPage: 1,  // 普通愿望数据page
      messageList: [
        '当前为预览模式！',
        '活动未开始',
        '活动已结束',
        '您不在活动的用户组中，没有参与活动的权限'
      ],
      text: '我祝福祖国越来越好！我祝福祖国越来越好！我祝福祖国越来越好！我祝福祖国越来越好！我祝福祖国越来越好！我祝福祖国越来越好！我祝福祖国越来越好！我祝福祖国越来越好！'
    }
  },
  computed: {
    isPreview() {
      return this.query.preview
    },
    params() {
      return Object.assign({limit: 20}, this.query)
    },
    paramsHot() {
      return Object.assign({limit: 20}, this.query)
    },
    pullUpLoadObj: function () {
      return this.pullUpLoad ? {
        threshold: 0,
        text: {more: '查看更多', noMore: '- 没有更多了 -'}
      } : false
    },
    pullDownRefreshObj: function () {
      return this.pullDownRefresh ? {
        threshold: parseInt(this.pullDownRefreshThreshold),
        stop: parseInt(this.pullDownRefreshStop),
        text: '刷新成功'
      } : false
    },
  },
  filters: {
    filterA(value, show) {
      if (show) return value
      if (!value) return ''
      if (value.length > 76) {
        return `${value.slice(0, 76)}...`
      } else {
        return value
      }
    }
  },
  watch: {
    wishText(val) {
      if (val && val.length > 500) {
        this.wishText = val.substring(0, 500)
      }
    },
    pullUpLoadObj: {
      handler(val) {
        const scroll = this.$refs.scroll.scroll
        if (val) {
          scroll.openPullUp()
        } else {
          scroll.closePullUp()
        }
      },
      deep: true
    },
    pullDownRefreshObj: {
      handler(val) {
        const scroll = this.$refs.scroll.scroll
        if (val) {
          scroll.openPullDown()
        } else {
          scroll.closePullDown()
        }
      },
      deep: true
    },
  },
  created() {
    // 获取置顶列表数据
    this.getHotData()
    // 获取愿望列表数据
    this.getWishData()
    // this.handleLineLimitArr()
  },
  mounted() {
    this.previewAlert()
  },
  methods: {
    previewAlert() {
      if (this.isPreview || this.itemStatus !== 0 || !this.rightClass) {
        let message
        if (!this.rightClass) {
          message = this.messageList[3]
        } else {
          message = this.isPreview ? '当前为预览模式！' : this.messageList[this.itemStatus]
        }
        this.$toast(message)
        return true
      }
    },
    logoutAlert() {
      if (this.logout) {
        let vm = this
        // 调用登陆接口
        CP.show_login(function(data) {
          // 表示当前登录状态为未登录的状态
          if (data.is_login === '1') {
            vm.$emit('update:logout', false)
            vm.$emit('login', data)
          }
        })
        return true
      }
    },
    exceptionUAAlert() {
      if (this.exceptionUA) {
        // 提示微信扫描二维码进入活动，反之前往客户端
        if (this.exceptionUA.need_qrcode) {
          this.$router.push({name: 'wxScan'})
        } else {
          this.exceptionUA.download_url && (window.location.href = this.exceptionUA.download_url)
        }
        return true
      }
    },
    bannerClick(url) {
      if (this.previewAlert()) return
      if (this.logoutAlert()) return
      url && (window.location.href = url)
    },
    showMore(item, index) {
      item.show = true
      this.hotData.splice(index, 1, item)
    },
    lineToggle(item, index) {
      item.show = true
      this.wishData.splice(index, 1, item)
    },
    handleLineLimitArr() {
      const length = this.wishData.length
      let arr = new Array(length)
      arr.fill(true)
      this.lineLimitArr = arr
    },
    zan(origin, index, id, favor, count) {
      if (this.exceptionUAAlert()) return
      if (this.previewAlert()) return
      if (this.logoutAlert()) return
      if (this.flag) return
      this.flag = true

      this.params.wish_id = id
      getChangeisfavor(this.params).then(res => {
        if (res.code === 3001) {
          count = favor ? count - 1 : count + 1
          if (origin === 'hot') {
            this.$set(this.hotData[index], 'is_favor', !favor)
            this.$set(this.hotData[index], 'favor_count', count)
          } else {
            this.$set(this.wishData[index], 'is_favor', !favor)
            this.$set(this.wishData[index], 'favor_count', count)
          }
        } else if (res.code === 5011) {
          this.$emit('update:needFocus', true)
        } else if (res.code === 5900) {
          this.handle5900(res.data)
        } else {
          this.$toast(res.msg)
        }
        this.flag = false
      })
    },
    handle5900(data) {
      // 提示微信扫描二维码进入活动，反之前往客户端
      if (data.need_qrcode) {
        this.$router.push({name: 'wxScan'})
      } else {
        data.redirect_url && (window.location.href = data.redirect_url)
      }
    },
    toggleHot() {
      if (this.previewAlert()) return
      if (this.logoutAlert()) return
      if (this.hotMoreFlag) {
        // 获取置顶列表数据，page递增
        this.getHotData()
      } else {
        this.hotLength = 1000000;
        // 首次获得的数据大于等于20，放开请求开关，反之隐藏更多按钮
        (this.hotData.length >= 20) ? this.hotMoreFlag = true : this.hotMore = false
      }
    },
    getHotData(reset) {
      if (reset) {
        this.hotPage = 1
        this.hotData = null
      }
      this.paramsHot.page = this.hotPage
      getSticky(this.paramsHot).then(res => {
        if (res.code === 3001) {
          const data = res.data
          if (!data.list.length) {
            // 为空没有新数据，手动forceUpdate
            this.$refs.scroll && this.$refs.scroll.forceUpdate()
            return
          }
          this.hotData = this.hotData ? this.hotData.concat(data.list) : data.list
          // 配置更多精选
          if (data.count > 6 && data.count <= 20) {
            this.hotMore = true
          } else {
            this.hotMore = (this.hotPage * 20 < data.count) ? true : false
          }
          // 更新页码
          this.hotPage += 1
          // if (this.hotPage * 20 < data.count) {
          //   this.hotPage += 1
          // }
        }
      })
    },
    getWishData(reset) {
      if (this.wishFlag) return
      this.wishFlag = true
      if (reset) {
        this.wishData = null
        this.wishPage = 1
      }
      this.params.page = this.wishPage
      getWish(this.params).then(res => {
        if (res.code === 3001) {
          if (res.data.list.length) {
            this.wishData = this.wishData ? this.wishData.concat(res.data.list) : res.data.list
            this.wishPage += 1
          } else {
            // 为空没有新数据，手动forceUpdate
            this.$refs.scroll && this.$refs.scroll.forceUpdate()
          }
        }
        this.wishFlag = false
      })
    },
    onPullingDown() {
      // 模拟更新数据
      setTimeout(() => {
        if (this._isDestroyed) {
          return
        }
        // window.location.reload()
        // 重置精选长度为6和更多精选点击首次标志
        this.hotMoreFlag = false
        this.hotLength = 6
        // 重置愿望列表数据
        this.getWishData(1)
        // 重置精选列表数据
        this.getHotData(1)
      }, 2000)
    },
    onPullingUp() {
      // 更新数据
      setTimeout(() => {
        if (this._isDestroyed) {
          return
        }
        // 获取愿望列表数据
        this.getWishData()
      }, 1500)
    },
    wishClick() {
      if (this.exceptionUAAlert()) return
      if (this.previewAlert()) return
      if (this.logoutAlert()) return
      this.wishTextareaDisplay = true

      // setTimeout(() => {
      //   this.$refs['textarea'].focus()
      // }, 100)
    },
    messageClick() {
      if (this.exceptionUAAlert()) return
      // 预览模式和非期组别不允许进入
      if (this.isPreview || !this.rightClass) {
        const message = this.isPreview ? '当前为预览模式！' : '您不在活动的用户组中，没有参与活动的权限'
        this.$toast(message)
        return
      }
      if (this.logoutAlert()) return
      this.$router.push({name: 'message', query: {...this.query}})
    },
    blurAction() {
      this.timer = setTimeout(() => {
        // 重置微信6.7.4版本之后，关闭输入法页面为还原的问题
        resetScrollTop()
      }, 100)
    },
    btnClose() {
      if (this.wishText) {
        this.wishText = ''
      }
      this.wishTextareaDisplay = false
    },
    spliceMessage(wishId, content) {
      let item = {
        wish_id: wishId,
        content,
        nickname: this.baseData.nickname,
        avatar_url: this.baseData.avatar_url,
        if_favor: false,
        favor_count: 0,
        created_at: getDate()
      }
      // 插入数据
      if (this.wishData) {
        this.wishData.unshift(item)
      } else {
        this.wishData = [item]
      }
    },
    btnConfirm() {
      if (this.wishText.length > 3) {
        if (this.flag) return
        this.flag = true

        const content = this.wishText
        const formData = new FormData();
        formData.append('content', content)
        getPushwish('/activity/api.php?m=front&subm=wishwall&action=pushwish', this.params, formData)
          .then(res => {
          if (res.code === 3001) {
            // 拼接留言信息
            this.spliceMessage(res.data.wish_id, content)
            this.baseData.prompt_text ?
              this.$message({
                message: this.baseData.prompt_text,
                url: this.baseData.redirect_url
              }) :
              this.$message({message: '恭喜！我们已收到您的消息，审核通过后可展示在活动首页，敬请关注。'})
          } else if (res.code === 5011) {
            this.$emit('update:needFocus', true)
          } else if (res.code === 5900) {
            this.handle5900(res.data)
          } else {
            this.$toast(res.msg)
          }
          this.flag = false
        })
        this.btnClose()
      } else if (this.wishText.length === 0) {
        this.$toast('请填写你的留言！')
      }
    }
  },
  beforeDestroy() {
    this.timer && clearTimeout(this.timer)
  },
  components: {
    Scroll
  }
}
</script>

<style lang="stylus" scoped>
@import "~assets/css/mixin"

.TemplateText
  background-color: #f6f6f6
  font-size: 0.14rem
  .scrollBox
    height: 100vh
    overflow: hidden
    .scroll-content
      .banner
        height: 1.8rem
        background-color: orange
        img
          width: 100%
          height: 100%
      .premium
        margin-bottom: 0.1rem
      .premium, .latest
        .title, .hotToggoleArea
          height: 0.3rem
          line-height: 0.3rem
        .title
          padding-left: 0.13rem
          background-color: #fff
          color: #9b9b9b
        .hotToggoleArea
          text-align: center
          color: #9b9b9b
        .content
          padding: 0 0.08rem
          .item
            margin-top: 0.1rem
            padding: 0.08rem
            min-height: 0.5rem
            background-color: #fff
            display: flex
            .item-avatar
              margin-right: 0.1rem
              .avatar
                width: 0.5rem
                height: 0.5rem
                border-radius: 50%
                background-color: #ccc
                overflow: hidden
                img
                  width: 100%
                  height: 100%
            .item-content
              flex: 1
              color: #9b9b9b
              .item-content-top
                margin-bottom: 0.1rem
                display: flex
                justify-content: space-between
                .top-right
                  margin-right: 0.12rem
                  &.active
                    color: #ec4d5e
                    color: var(--color)
                  .iconfont
                    margin-right: 0.05rem
                .top-left
                  .name
                    margin-bottom: 0.08rem
                    color: #333
                  .time
                    font-size: 0.12rem
              .item-content-bottom
                .lineLimit
                  line-clamp(4)
                .text
                  .showMore
                    margin-left: 0.1rem
                    color: #ee4b5b
                    text-decoration: underline
                .operate
                  display: flex
                  justify-content: flex-end
                  .showMore
                    margin-right: 0.1rem
                    color: #ee4b5b
                    text-decoration: underline
  .mark
    margin-top: 0.17rem
    font-size: 0.12rem
    color: #cdcdcd
    display: flex
    justify-content: center
    img
      margin-right: 0.12rem
      width: 0.6rem
      height: 0.12rem
      background-color: orange
  .operation
    position: fixed
    left: 0
    bottom: 0.1rem
    width: 100%
    height: 0.32rem
    display: flex
    justify-content: center
    .item
      height: 0.32rem
      line-height: 0.32rem
      text-align: center
      border-radius: 0.16rem
    .item-wish
      width: 2.58rem
      background-color: #ec4d5e
      background-color: var(--color)
      color: #fff
    .item-message
      margin-left: 0.1rem
      width: 0.8rem
      background-color: #fff
      box-shadow: 0 0 0.04rem 0 rgba(0,0,0,0.5)
      .iconfont
        color: #ec4d5e
        color: var(--color)
        font-size: 0.2rem
  .wishLayer
    position: fixed
    top: 0
    left: 0
    right: 0
    bottom: 0
    background-color: rgba(0,0,0,0.5)
    overflow: hidden
    &.easein
      animation: easein 0.5s
      @keyframes easein {
        0% {opacity: 0}
        100% {opacity: 1}
      }
    .wishArea
      position: absolute
      left: 0
      bottom: 0
      padding: 0.1rem 0
      width: 100%
      // height: 2.06rem
      height: 1.32rem
      background-color: #f4f4f4
      display: flex
      .wishArea-textarea
        margin-left: 0.1rem
        // width: 84%
        flex: 1
        height: 1.32rem
        background-color: #fff
        border: 1px solid #e4e4e4
        position: relative
        .countArea
          position: absolute
          right: 0.1rem
          bottom: 0.08rem
          color: #ccc
        textarea
          width: 100%
          height: 1.12rem
          box-sizing: border-box
          padding: 0.5em
          border: none
          appearance: none
          outline: none
      .wishArea-btn
        width: 0.55rem
        display: flex
        justify-content: center
        align-items: center
        .btn-confirm
          width: 90%
          height: 0.3rem
          line-height: 0.3rem
          text-align: center
          color: #a0a0a0
          &.active
            color: #ec4d5e
            color: var(--color)
</style>

